import { Helmet } from "react-helmet";

export function TermsPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-8 leading-relaxed text-gray-800">
      <Helmet>
        <title>利用規約 - Refloop</title>
      </Helmet>
      <h1 className="mb-8 text-xl font-bold">refloop 利用規約</h1>

      <Section title="第1条（目的）">
        <p>
          refloop
          利用規約（以下「本規約」といいます）は、日本インフォメーション株式会社（以下「当社」といいます）が運営するウェブサイト「refloop」および「refloop」で提供する機能ならびにソフトウェア（以下「本サービス」といいます）について、本サービスの提供条件および本サービスを利用するすべてのユーザー（以下「利用者」といいます）と当社との間の権利義務関係を定めるものです。
        </p>
      </Section>

      <Section title="第2条（定義）">
        <p>本規約において使用する用語は、各々以下に定める意味を有するものとします。</p>
        <ol className="list-decimal pl-6">
          <li>
            「有料会員」とは、名称のいかんを問わず、本サービスにおいて一定の機能を利用するための対価として利用料金を支払う利用者のことをいいます。
          </li>
          <li>
            「知的財産権」とは、著作権、特許権、実用新案権、意匠権、商標権その他の知的財産権（それらの権利を取得し、またはそれらの権利につき登録等を出願する権利を含みます）を意味します。
          </li>
          <li>
            「投稿データ」とは、利用者が本サービスを利用して投稿、その他送信する一切のデータを意味します。
          </li>
        </ol>
      </Section>

      <Section title="第3条（適用）">
        <ol className="list-decimal pl-6">
          <li>本規約は、利用者が本サービスを利用する際の全てに適用されるものとします。</li>
          <li>
            当社は、本規約とは別に本サービスの利用に関するルール等を定めることがあります。当該ルール等は、その名称の如何に拘わらず、本規約の一部を構成するものとします。
          </li>
          <li>
            本規約の内容と、前項のルール等その他の本規約外における内容が異なる場合は、本規約の規定が優先して適用されるものとします。
          </li>
        </ol>
      </Section>

      <Section title="第4条（利用条件）">
        <ol className="list-decimal pl-6">
          <li>
            利用者は、本サービスの利用を希望する場合、自らの判断と責任において本規約の内容を承諾の上、本サービスを利用するものとします。
          </li>
          <li>
            利用者は、本サービスの利用にあたり登録その他の情報（以下「登録情報等」といいます）を提供する場合は、正確かつ最新の情報を提供するものとします。
          </li>
          <li>
            利用者は、登録情報等について、自己の責任において任意に変更、追加、削除等の管理を行うことができるものとします。
          </li>
          <li>
            本サービスにおいて提供される情報は、施設・イベント運営者および利用者によって投稿されたものであり、当社は、本サービスに掲載する飲食店に関する情報の正確性を保証していません。利用者が本サービスにおいて提供される情報の正確性を求める場合には、利用者において直接、施設・イベント運営者等に確認するものとします。
          </li>
        </ol>
      </Section>

      <Section title="第5条（利用環境とセキュリティ）">
        <ol className="list-decimal pl-6">
          <li>
            利用者は、自己の責任と費用負担において、利用環境（コンピュータ、ソフトウェア等）を準備し、セキュリティ対策を実施するものとします。
          </li>
          <li>
            当社は、利用者の利用環境に起因して発生したセキュリティ上の問題や損害について、一切の責任を負わないものとします。
          </li>
          <li>
            当社は、本サービスの提供にあたり、SSL等の適切なセキュリティ対策を実施するものとします。
          </li>
        </ol>
      </Section>

      <Section title="第6条（登録メールアドレスおよびパスワード）">
        <ol className="list-decimal pl-6">
          <li>
            利用者は、登録メールアドレスとして、自己の管理下にある有効なメールアドレスを登録し、これが利用できなくなった場合は速やかに変更するものとします。
          </li>
          <li>
            利用者は、登録メールアドレスおよびパスワードを適切に管理し、これらを第三者に開示、提供、または利用させてはならないものとします。
          </li>
        </ol>
      </Section>

      <Section title="第7条（連絡/通知）">
        <ol className="list-decimal pl-6">
          <li>
            利用者は、本サービスに関する問合せその他の当社への連絡または通知を、当社の指定する連絡先（ウェブサイト内のお問い合わせフォームまたは当社メールアドレス）へ行うものとします。
          </li>
          <li>
            当社から利用者への連絡または通知は、利用者の登録メールアドレスで行うものとし、当社が連絡または通知を発信した時点で利用者に到達したものとみなします。
          </li>
        </ol>
      </Section>

      <Section title="第8条（外部サービスとの連携）">
        <p>
          利用者は、本サービスと外部サービスを連携する場合、外部サービスの規約に従うものとします。
        </p>
      </Section>

      <Section title="第9条（有料会員機能）">
        <ol className="list-decimal pl-6">
          <li>利用者は、本規約の内容を承諾の上、有料会員登録をすることができます。</li>
          <li>
            有料会員は、有料会員登録が完了した時点から、有料会員登録画面に表示された機能を利用することができます。
          </li>
          <li>
            有料会員は、当社に対し、前項の対価（1か月間の利用の対価）として、当社の指定する方法により、当社の指定する月額利用料を支払うものとします。
          </li>
          <li>
            有料会員は、有料会員の解除または退会の手続をすることで、第2項に定める機能の利用を停止することができます。
          </li>
          <li>
            月額利用料は、有料会員登録が完了した時点で発生し、有料会員が、1か月分（1か月とは、有料会員登録完了日の翌日からその翌月の有料会員登録完了日と同じ日までをいいます。翌月に有料会員登録完了日と同じ日がない場合は各月末日までを1か月とします。）の利用の途中で有料会員の解除または退会の手続をした場合であっても、1か月分の月額利用料をお支払いいただく必要があります。
          </li>
          <li>
            有料会員は、有料会員登録に関し、特定商取引に関する法律第15条の3に基づく申込みの撤回または契約の解除をすることはできないものとします。
          </li>
          <li>
            当社は、月額利用料を改定する場合、改定日の1か月前までに、本サービス上での表示または利用者の登録メールアドレスへ通知する方法により、有料会員にその旨を告知するものとします。
          </li>
          <li>
            有料会員が前項の通知を受領後、1か月の間に有料会員の解除および退会の手続を取らなかった場合、有料会員は月額利用料の改定を承諾したものとします。
          </li>
        </ol>
      </Section>

      <Section title="第10条（利用者の禁止事項と違反行為への対応）">
        <ol className="list-decimal pl-6">
          <li>
            利用者は、本サービスの利用にあたり、以下の行為を行ってはならないものとします。
            <ol className="mt-1 list-none pl-4">
              {[
                "本規約に違反する行為",
                "法令または公序良俗に違反する行為",
                "当社、他の利用者または第三者の権利を侵害する行為",
                "本サービスによる不正な利益を得る行為",
                "本サービスの運営を妨害する行為",
                "ID、パスワードを不正に使用する行為、または他人名義での利用する行為",
                "複数人でアカウント情報を共有し、本サービスを利用する行為",
                "虚偽の情報を提供する行為",
                "有害なコンピュータプログラム等を送信する行為",
                "反社会的勢力に対する利益供与その他の協力をすること",
                "犯罪による収益の移転行為およびこれを助長、援助等すること",
                "不正アクセス行為、またはこれを助長する行為",
                "本サービスの誤作動を誘引すること",
                "本サービスが通常意図しないバグを利用する動作を生じさせる、または、通常意図しない効果を及ぼす外部ツールの利用、作成、または頒布",
                "当社のサーバー、コンピュータ等に過度の負担をかけること",
                "当社、当社のグループ会社、その他第三者にコンピュータウイルス等の有害なプログラムを送信し、または流布すること",
                "その他、当社が不適切と判断する行為"
              ].map((text, i) => (
                <li key={i}>
                  ({i + 1}) {text}
                </li>
              ))}
            </ol>
          </li>
          <li>
            利用者が前項の定めに違反した場合、または当社に対する債務を履行しない場合、当社は、利用者に事前に通知することなく、以下の各号に定める措置の一部または全部を講じることができるものとします。
            <ol className="mt-1 list-none pl-4">
              <li>(1) 本サービスの利用停止</li>
              <li>(2) 投稿データの削除</li>
              <li>(3) 会員データの削除</li>
              <li>(4) 不当に得た利益を弊社に返還いただくこと</li>
              <li>
                (5)
                違反事実の情報提供（民事事件および刑事事件、その他に該当する可能性がある場合の警察その他の公的機関への情報提供を含みます）
              </li>
            </ol>
          </li>
          <li>
            第1項に違反したことによって当社に損失ないし損害が生じた場合、利用者は、当社に対し、違反したことにより利用者が得た利益を返還し、当社に生じた損害を、直ちに賠償するものとします。
          </li>
        </ol>
      </Section>

      <Section title="第11条（個人情報および個人関連情報の取扱い）">
        <ol className="list-decimal pl-6">
          <li>
            当社は、利用者から以下の情報を取得します。
            <ol className="mt-1 list-none pl-4">
              <li>
                (1)
                ニックネーム、性別、生年月、メールアドレス、自宅郵便番号、職種および勤務形態、世帯情報およびおでかけ同伴タイプ、おでかけに関連する嗜好及び行動情報
                ※ ニックネームは本名以外のものをお使いください。
              </li>
              <li>(2) 位置情報、端末情報</li>
              <li>(3) Cookie、リファラ、IPアドレス、サーバーアクセスログに関する情報</li>
              <li>(4) ADID、IDFA その他識別子</li>
            </ol>
          </li>
          <li>
            当社は、前項で取得した情報を以下の目的で利用します。
            <ol className="mt-1 list-none pl-4">
              <li>(1) 本サービスにおける利用者の識別、管理のため</li>
              <li>(2) 本サービスの提供、改善のため</li>
              <li>(3) 本サービスの利用状況の把握、分析のため</li>
              <li>(4) 本サービスに関するご案内、お問合せ等への対応のため</li>
              <li>
                (5)
                利用者の行動測定、トラフィック測定ならびに各測定の分析および分析結果についての情報発信のため
              </li>
              <li>(6) 当社または当社提携先の提供する商品・サービスの改善または開発のため</li>
              <li>
                (7)
                当社または当社提携先の提供する商品・サービスに関する広告の配信および効果測定のため
              </li>
            </ol>
          </li>
          <li>
            個人情報および個人関連情報のその他の取扱いの内容については、当社の「個人情報等の取扱いについて」（
            <a
              href="https://www.nicnet.co.jp/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline"
            >
              https://www.nicnet.co.jp/privacy/
            </a>
            ）をご覧下さい。
          </li>
        </ol>
      </Section>

      <Section title="第12条（権利義務の譲渡等）">
        <ol className="list-decimal pl-6">
          <li>
            利用者は、当社の事前の書面による承諾なしに、本規約上の権利または義務を第三者に譲渡、移転、担保設定等することはできないものとします。
          </li>
          <li>
            当社は、本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い、本規約上の地位、本規約に基づく権利義務、および利用者の登録情報を当該事業譲渡の譲受人に譲渡することができるものとします。
          </li>
        </ol>
      </Section>

      <Section title="第13条（知的財産権）">
        <p>
          本サービスに関する知的財産権は全て当社または当社にライセンスを許諾している者に帰属しており、本規約に基づく本サービスの利用許諾は、本サービスに関する当社または当社にライセンスを許諾している者の知的財産権の使用許諾を意味するものではありません。
        </p>
      </Section>

      <Section title="第14条（投稿データ）">
        <ol className="list-decimal pl-6">
          <li>
            利用者は、投稿データについて、自らが投稿その他送信することについての適法な権利を有していること、および投稿データが第三者の権利を侵害していないことについて、当社に対し表明し、保証するものとします。
          </li>
          <li>
            利用者は、当社に対し、投稿データについて、使用、複製、配布、派生著作物の作成、公開、改変等することに関するライセンスを、無償で、譲渡可能かつサブライセンス可能な非独占的
            worldwide なものとして、本サービスの提供に必要な期間付与するものとします。
          </li>
          <li>
            利用者は、投稿データに関し、当社および当社の承継者等に対して著作者人格権を行使しないものとします。
          </li>
        </ol>
      </Section>

      <Section title="第15条（保証の否認および免責）">
        <ol className="list-decimal pl-6">
          <li>
            当社は、以下の情報の他本サービスにおいて提供される一切の情報およびコンテンツについて、その完全性、正確性、有用性等に関していかなる保証も行わないものとします。
            <ol className="mt-1 list-none pl-4">
              <li>(1) 施設・イベント情報</li>
              <li>(2) 投稿データ</li>
            </ol>
          </li>
          <li>
            当社は、本サービスの利用により生じた利用者の損害について、当社の故意または重過失による場合を除き、一切の責任を負わないものとします。
          </li>
          <li>
            前項の定めにかかわらず、利用者に対する本サービスの提供が消費者契約法に定める消費者契約に該当する場合、当社は、当社の故意または重過失に起因する場合を除き、逸失利益その他の特別の事情によって生じた損害を賠償する責任を負わず、通常生じうる損害の範囲内で、かつ、有料会員であるかを問わず有料会員が当社に支払う1年分の利用料相当額を上限として損害賠償責任を負うものとします。
          </li>
          <li>
            当社の重過失に起因して利用者に損害が生じた場合、当社は、逸失利益その他の特別の事情によって生じた損害を賠償する責任を負わず、通常生じうる損害の範囲内で、かつ、有料会員であるかを問わず有料会員が当社に支払う1年分の利用料相当額を上限として損害賠償責任を負うものとします。ただし、本サービスの提供が消費者契約法に定める消費者契約に該当する場合はこの限りではありません。
          </li>
          <li>
            当社は、利用者間の紛争について一切関与せず、かかる紛争に基づく利用者の損害について一切の責任を負わないものとします。
          </li>
        </ol>
      </Section>

      <Section title="第16条（退会）">
        <ol className="list-decimal pl-6">
          <li>利用者は、当社所定の退会手続きに従い、本サービスから退会できるものとします。</li>
          <li>
            当社は、退会した利用者が自ら登録した個人情報および個人関連情報について、退会後は保有する必要がなくなった場合、遅滞なく消去するものとします。ただし、法令に基づき保存しなければならない情報はこの限りではありません。
          </li>
          <li>
            当社は、退会した利用者のその他の個人情報および個人関連情報（前項に規定するものを除く）の取扱いについては、法令および本規約の定めに従うものとします。
          </li>
        </ol>
      </Section>

      <Section title="第17条（本サービスの変更・一時停止、終了）">
        <ol className="list-decimal pl-6">
          <li>
            当社は、利用者に事前に通知することなく、本サービスの全部または一部を変更、一時停止、終了（以下「本サービスの変更等」といいます）することができるものとします。
          </li>
          <li>
            当社は、本サービスの終了時には、利用者に事前に通知するものとし、可能な限り利用者の被害の防止に努めるものとします。
          </li>
          <li>
            当社は、本サービスの変更等により利用者に生じた損害について、当社の責めに帰すべき事由がある場合を除き、一切責任を負わないものとします。
          </li>
        </ol>
      </Section>

      <Section title="第18条（規約の変更）">
        <ol className="list-decimal pl-6">
          <li>
            当社は、次の各号のいずれかに該当する場合、利用者の承諾を得ることなく、本規約の内容を変更すること（本規約に新たな内容を追加することを含む。）ができるものとします。
            <ol className="mt-1 list-none pl-4">
              <li>(1) 利用規約の変更が、利用者の一般の利益に合致するとき。</li>
              <li>
                (2)
                利用規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるとき。
              </li>
            </ol>
          </li>
          <li>
            本規約が変更された場合、別途効力発生日を定めた場合を除き、サービスサイトへ掲載された時点より効力を生じるものとします。
          </li>
        </ol>
      </Section>

      <Section title="第19条（分離可能性）">
        <p>
          本規約のいずれかの条項が法令に抵触するため無効または執行不能と判断された場合であっても、本規約の残りの規定は、継続して完全に効力を有するものとします。また、一部が無効または執行不能と判断された規定については、その他の部分の効力は維持されるものとします。
        </p>
      </Section>

      <Section title="第20条（準拠法・裁判管轄）">
        <ol className="list-decimal pl-6">
          <li>本規約の解釈、適用、履行については、日本法を準拠法とします。</li>
          <li>
            本サービスまたは本規約に関する利用者と当社との間の紛争は、名古屋地方裁判所または名古屋簡易裁判所を第一審の専属的合意管轄裁判所とします。
          </li>
        </ol>
      </Section>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mb-6">
      <h2 className="mb-2 mt-6 text-base font-bold">{title}</h2>
      <div className="space-y-2 text-sm">{children}</div>
    </section>
  );
}
